import React, { useState, useContext } from "react";
import { Dialog } from '@progress/kendo-react-dialogs';
import { useAttributeFormBuilder } from "../../../../Hooks/Display/useComponentProperties";
import { useTranslation } from 'react-i18next';
import { usePropsStoreValue } from '../../../../Hooks/PropStore/usePropsStore';
import GenericTranslationDialog from '../../../Entities/GenericTranslationDialog';
import { GlobalContext } from "../../../../Renderers/GlobalContext";

const EditStepDialog = ({ handleClose }) => {

    const { t } = useTranslation([
        "display/components/form"
    ]);

    const { subscription } = useContext(GlobalContext).state

    const [{ selectedStepId, steps }, dispatch] = useAttributeFormBuilder();
    const project = usePropsStoreValue("project");
    const [showLabelTranslationDialog, setShowLabelTranslationDialog] = useState(false);

    const step = steps.find(step => step.id === selectedStepId)
    const [name, setName] = useState(step.name || "");
    const [languages, setLanguages] = useState(step.languages || {});
    const [message, setMessage] = useState({
        isError: false,
        text: ""
    });

    const handleSave = () => {
        dispatch.updateStepName(name);
        dispatch.updateStepLanguages(languages);
        handleClose();
    }

    const handleChangeName = (event) => {
        const filteredSteps = steps.filter(step => step.id !== selectedStepId);
        const isNameEmpty = event.target.value.trim() === "";
        const isNameTaken = filteredSteps.some(step => step.name.trim().toLowerCase() === event.target.value.trim().toLowerCase());

        setName(event.target.value);
        if (isNameEmpty) {
            setMessage({
                isError: true,
                text: t("step.edit_step_dialog.errors.name_required", { ns: "display/components/form" })
            });
            return;
        } else {
            setMessage({
                isError: false,
                text: ""
            });
        }
        if (isNameTaken) {
            setMessage({
                isError: true,
                text: t("step.edit_step_dialog.errors.name_taken", { ns: "display/components/form" })
            });
            return;
        } else {
            setMessage({
                isError: false,
                text: ""
            });
        }
    };

    const setLabelTranslation = (data) => {
        setLanguages(data);
        setShowLabelTranslationDialog(false);
    }

    return (
        <Dialog
            title={t("step.edit_step_dialog.title", { ns: "display/components/form" })}
            onClose={handleClose}
        >
            <form>
                <div className="mb-3">
                    <label className="form-label" required>
                        {t("step.edit_step_dialog.name_field_label", { ns: "display/components/form" })}
                    </label>
                    <span className="text-danger ms-1">{message.text}</span>
                    <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={handleChangeName}
                    />
                </div>
                {subscription.numOfLanguages > 1 &&
                    <div className="mb-3">
                        <div className="form-label d-inline-block cursor-pointer" onClick={() => {
                            setShowLabelTranslationDialog(true)
                        }}>
                            <span className="text-primary">
                                {t("form_labels.label_translations")}
                            </span>
                        </div>
                    </div>
                }
                {showLabelTranslationDialog && (
                    <GenericTranslationDialog
                        onClose={() => { setShowLabelTranslationDialog(false) }}
                        onSave={setLabelTranslation}
                        languages={languages}
                        project={project}
                        fields={["name"]}
                        type={t("form_action_dialog.action_field_label")}
                    />
                )}
                <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
                        {t("step.edit_step_dialog.buttons.cancel", { ns: "display/components/form" })}
                    </button>
                    <button type="button" className="btn btn-primary" disabled={message.isError} onClick={handleSave}>
                        {t("step.edit_step_dialog.buttons.save", { ns: "display/components/form" })}
                    </button>
                </div>
            </form>
        </Dialog>
    );
}

export default EditStepDialog;